// extracted by mini-css-extract-plugin
module.exports = {"switch":"language-changer_switch__1eTS_"};